import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useNavigate } from "react-router-dom";
import "../studio.css";

/**
 * Markdown for chat replies and canvas blocks. Internal links (/experiments/…) go through
 * the app router (HashRouter); external links open in a new tab.
 */
export default function Markdown({ children, className = "" }: { children: string; className?: string }) {
  const navigate = useNavigate();
  return (
    <div className={`studio-md ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href = "", children: label }) =>
            href.startsWith("/") ? (
              <a
                href={`#${href}`}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(href);
                }}
              >
                {label}
              </a>
            ) : (
              <a href={href} target="_blank" rel="noopener noreferrer">
                {label}
              </a>
            ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
